<template>
  <div class="">
    <el-form label-width="120px">
      <el-form-item label="企业名称" required="">
        <el-tag v-show="corp_name">{{ corp_name }}</el-tag>
        <el-tag style="margin-left: 8px" effect="dark" :disabled="isEdit" @click="changeSource">{{ corp_name ? '修改' : '选择' }}</el-tag>
        <!-- <el-select v-model="corp_id" placeholder="请选择" :disabled="isEdit">
          <el-option v-for="item in corpidoptions" :key="item.corp_id" :label="item.corp_name" :value="item.corp_id" />
        </el-select> -->
      </el-form-item>

      <el-form-item label="汇报日期" required="">
        <el-radio-group v-model="corn_day" :aria-hidden="false">
          <el-radio v-for="(day, index) in daysOfWeek" :key="index" :label="day.value">{{ day.label }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="发送时间">
        <el-time-select
          v-model="corn_time"
          :picker-options="{
            start: '00:00',
            step: '00:15',
            end: '23:45'
          }"
          placeholder="选择时间"
        >
        </el-time-select>
      </el-form-item>

      <el-form-item label="" style="height: 10px">
        <el-button style="float: right" type="primary" @click="confirm">确定</el-button>
      </el-form-item>
    </el-form>

    <el-dialog title="企业列表" :visible.sync="enterlistVisible" :destroy-on-close="true" width="30%" :close-on-click-modal="false" :append-to-body="true">
      <enterlist ref="soucelistview" @labelchoose="labelchoose" />
    </el-dialog>
  </div>
</template>

<script>
import { boundUpdate, boundCreate } from '@/api/tencentAccountIni'
import enterlist from './enterlist.vue'

export default {
  props: {
    report_template_id: {
      type: Number,
      default: null
    }
  },
  components: { enterlist },
  data() {
    return {
      corp_id: null,
      corn_time: null,
      corn_time_text: null,
      corpidoptions: [],
      corn_day: null,
      corp_name: null,
      isEdit: false,
      id: null,
      enterlistVisible: false,
      daysOfWeek: [
        { value: 1, label: '周一' },
        { value: 2, label: '周二' },
        { value: 3, label: '周三' },
        { value: 4, label: '周四' },
        { value: 5, label: '周五' },
        { value: 6, label: '周六' },
        { value: 0, label: '周日' }
      ]
    }
  },
  created() {},
  methods: {
    send(row) {
      if (row) {
        this.isEdit = true
        this.id = row.id
        this.corp_id = row.corp_id
        this.corn_time = row.corn_time_text
        this.corn_day = row.corn_day
        this.corp_name = row.corp_name
      }
    },
    changeSource() {
      this.enterlistVisible = true
    },
    labelchoose(backitem) {
      this.enterlistVisible = false
      this.corp_name = backitem.corp_name
      this.corp_id = backitem.corp_id
    },
    async confirm() {
      if (!this.corp_id) {
        this.$message({
          message: '请选择企业',
          type: 'error'
        })
        return
      }
      if (!this.corn_day) {
        this.$message({
          message: '请选择汇报日期',
          type: 'error'
        })
        return
      }
      if (!this.corn_time) {
        this.$message({
          message: '请选择添加汇报时间',
          type: 'error'
        })
        return
      }

      if (this.isEdit) {
        const result = {
          id: this.id,
          corn_day: this.corn_day,
          corn_time: this.corn_time
        }
        await boundUpdate(result)
        this.$emit('update')
      } else {
        const result = {
          corp_id: this.corp_id,
          report_template_id: this.report_template_id,
          corn_day: this.corn_day,
          corn_time: this.corn_time
        }
        await boundCreate(result)
        this.$emit('update')
      }
    }
  }
}
</script>

<style scoped>
</style>
